import { createSlice } from '@reduxjs/toolkit';

// TODO: This slice should be deprecated and removed in favor of using the accountId from the route params in the components that need it. This will ensure that the selected account is always in sync with the URL and will simplify the state management.
export const selectedAccountSlice = createSlice({
  name: 'selectedAccount',
  initialState: {},
  reducers: {
    setSelectedAccount: (state, action) => {
      return action.payload;
    },
  },
});

export const { setSelectedAccount } = selectedAccountSlice.actions;

export const getSelectedAccount = (state) => state?.selectedAccount;

export default selectedAccountSlice.reducer;
